/**
 * GlcWorkerOnOff Style01 - On/Off (reuse OnOff)
 */
import type { TraitControlProps } from './types'
import { OnOffStyle01 } from './OnOffStyle01'

export function GlcWorkerOnOffStyle01(props: TraitControlProps) {
  return <OnOffStyle01 {...props} />
}
